import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import avatar from "../../../assets/img/avatar/user-dummy-img.jpg";
import "./sidebar.scss";
import { question } from "../../../helpers/swal";
import { BiChevronLeft } from "react-icons/bi";
import { AiOutlineFileText, AiOutlineSafetyCertificate } from "react-icons/ai";
import { FiLogOut } from "react-icons/fi";
import { chevronClicked } from "../../../store/slices/sidebar-slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { logout } from "../../../store/slices/auth-slice";
import { encryptedLocalStorage } from "../../../helpers/functions/encrypt-storage";
import { AiOutlineFile } from "react-icons/ai";
import { AiOutlinePrinter } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { HiOutlineShoppingCart } from "react-icons/hi";
import axios from "axios";
import { settings } from "../../../helpers/settings";
import authHeader from "../../../helpers/functions/auth-header";
import React, { useState, useEffect } from "react";
import { AiOutlineSetting } from "react-icons/ai";
import { FiBox } from "react-icons/fi";
import { AiOutlineBarChart } from "react-icons/ai";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { AiOutlineCheckSquare } from "react-icons/ai";
import { AiOutlineMessage } from "react-icons/ai";

const Sidebar = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${settings.apiURL}/get_profile.php`, {
          headers: authHeader(),
        });

        if (response.data.success) {
          setProfile(response.data.user);
          localStorage.setItem("user_type", response.data.user.user_type);
        }
      } catch (error) {
        console.error("Sidebar profil bilgisi alınamadı", error);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("user_profile");
    if (stored) {
      const userData = JSON.parse(stored);
      setProfile(userData);
      localStorage.setItem("user_type", userData.user_type);
    }
  }, []);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { sidebarLeft } = useAppSelector((state) => state.left);
  const dispatch = useAppDispatch();

  const userEmail = localStorage.getItem("email");
  const userType = localStorage.getItem("user_type");

  const isAdmin = ["admin@customzonpod.com", "mhmtmnctl20@gmail.com"].includes(
    userEmail
  );
  const isAccounting = [
    "fuatsaglam1983@gmail.com",
    "mhmtmnctl20@gmail.com",
  ].includes(userEmail);

  const showMyTasks = userType === "employee" && !isAdmin;

  const handleSidebarToggle = () => {
    dispatch(chevronClicked(!sidebarLeft));
  };

  const handleLogout = () => {
    question("Logout", "Are you sure to logout?").then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        encryptedLocalStorage.removeItem("token");
        localStorage.removeItem("first_name");
        localStorage.removeItem("last_name");
        localStorage.removeItem("user_id");
        localStorage.removeItem("user");
        localStorage.removeItem("user_type");
        sessionStorage.removeItem("googleApisToken");
        navigate("/");
      }
    });
  };

  return (
    <Navbar
      bg="light"
      expand="lg"
      className={sidebarLeft ? "admin-navbar admin-left" : "admin-navbar"}
      variant="dark"
      style={{ height: "100vh", overflowY: "auto", paddingBottom: "80px" }}
    >
      <Container>
        <>
          <div className="avatar">
            <h5>CUSTOMZON-POD</h5>
            <div className="admin-brand">
              <Navbar.Brand>
                <img
                  src={
                    profile?.profile_image
                      ? `https://mayatxupload.com/mayaUp/uploads/profile_images/${profile.profile_image}`
                      : avatar
                  }
                  alt="avatar"
                  className="img-fluid rounded-circle"
                  style={{ width: "60px", height: "60px", objectFit: "cover" }}
                />
              </Navbar.Brand>
              <p style={{ margin: 0 }}>
                {profile?.first_name} {profile?.last_name}
              </p>
              <p style={{ margin: 0, fontSize: "12px", color: "#6b7280" }}>
                {userType === "employee" ? "👨‍💼 Employee" : "🏪 External Store"}
              </p>

              <Nav.Link
                as={Link}
                to="/profile"
                active={pathname.startsWith("/profile")}
                style={{
                  paddingLeft: "0",
                  fontSize: "13px",
                  color: "#007bff",
                  textDecoration: "underline",
                  marginTop: "4px",
                }}
              >
                Edit Profile
              </Nav.Link>
            </div>
          </div>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {userEmail === "embroidery@txmaya.com" ? (
                <>
                  <Nav.Link
                    as={Link}
                    to="/admin/embroidery-orders"
                    active={pathname.startsWith("/admin/embroidery-orders")}
                  >
                    <AiOutlineMail style={{ marginRight: "8px" }} /> Embroidery
                    Files
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/embroidery-my-orders"
                    active={pathname.startsWith("/embroidery-my-orders")}
                  >
                    <HiOutlineShoppingCart style={{ marginRight: "10px" }} />{" "}
                    Embroidery Orders
                  </Nav.Link>
                  <Nav.Link onClick={handleLogout}>
                    <FiLogOut style={{ marginRight: "8px" }} /> Logout
                  </Nav.Link>
                </>
              ) : (
                <>
                  <Nav.Link
                    as={Link}
                    to="/send-files"
                    active={pathname.startsWith("/send-files")}
                  >
                    <AiOutlineCloudUpload style={{ marginRight: "8px" }} /> Send
                    Files
                  </Nav.Link>

                  {![
                    "houstonorders@txmaya.com",
                    "dallasorders@txmaya.com",
                  ].includes(localStorage.getItem("email")) && (
                    <Nav.Link as={Link} to="/my-files">
                      <AiOutlineFile style={{ marginRight: "8px" }} /> My Files
                    </Nav.Link>
                  )}

                  {userEmail !== "admin@customzonpod.com" && (
                    <Nav.Link
                      as={Link}
                      to="/my-orders"
                      active={pathname.startsWith("/my-orders")}
                    >
                      <HiOutlineShoppingCart style={{ marginRight: "10px" }} />{" "}
                      My Orders
                    </Nav.Link>
                  )}

                  {/* My Tasks sadece employee'lar için */}
                  {showMyTasks && (
                    <Nav.Link
                      as={Link}
                      to="/my-tasks"
                      active={pathname.startsWith("/my-tasks")}
                    >
                      <AiOutlineCheckSquare style={{ marginRight: "8px" }} /> My
                      Tasks
                    </Nav.Link>
                  )}

                  {userEmail !== "embroidery@txmaya.com" && (
                    <Nav.Link
                      as={Link}
                      to="/tickets"
                      active={pathname.startsWith("/tickets")}
                    >
                      <AiOutlineMessage style={{ marginRight: "8px" }} />
                      My Tickets
                    </Nav.Link>
                  )}

                  <Nav.Link
                    as={Link}
                    to="/inventory"
                    active={pathname.startsWith("/inventory")}
                  >
                    <FiBox style={{ marginRight: "8px" }} /> Inventory
                  </Nav.Link>

                  {isAccounting && (
                    <Nav.Link
                      as={Link}
                      to="/report"
                      active={pathname.startsWith("/report")}
                    >
                      <AiOutlineFileText style={{ marginRight: "-15px" }} />{" "}
                      Accounting Report
                    </Nav.Link>
                  )}

                  {userEmail === "mhmtmnctl20@gmail.com" && (
                    <Nav.Link
                      as={Link}
                      to="/admin/production-stats"
                      active={pathname.startsWith("/admin/production-stats")}
                    >
                      <AiOutlineBarChart style={{ marginRight: "-8px" }} />{" "}
                      Production Stats
                    </Nav.Link>
                  )}

                  {isAdmin && (
                    <>
                      <Nav.Link
                        as={Link}
                        to="/admin/files"
                        active={pathname.startsWith("/admin/files")}
                      >
                        <AiOutlinePrinter style={{ marginRight: "8px" }} />{" "}
                        Admin Files
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        to="/admin/task-management"
                        active={pathname.startsWith("/admin/task-management")}
                      >
                        <AiOutlineCheckSquare style={{ marginRight: "8px" }} />
                        Task Management
                      </Nav.Link>

                      {userEmail === "mhmtmnctl20@gmail.com" && (
                        <>
                          <div className="mt-3 mb-1 ps-2 text-muted fw-bold">
                            Management
                          </div>

                          <Nav.Link
                            as={Link}
                            to="/admin/users"
                            active={pathname.startsWith("/admin-users")}
                            className="ps-4"
                          >
                            <AiOutlineSetting style={{ marginRight: "8px" }} />{" "}
                            Edit Users
                          </Nav.Link>

                          <Nav.Link
                            as={Link}
                            to="/admin-orders"
                            active={pathname.startsWith("/admin-orders")}
                            className="ps-4"
                          >
                            <HiOutlineShoppingCart
                              style={{ marginRight: "8px" }}
                            />{" "}
                            Edit Orders
                          </Nav.Link>

                          <Nav.Link
                            as={Link}
                            to="/admin/mockup-editor"
                            active={pathname.startsWith("/admin/mockup-editor")}
                            className="ps-4"
                          >
                            <AiOutlineSetting
                              style={{
                                marginRight: "6px",
                                verticalAlign: "middle",
                              }}
                            />{" "}
                            Mockups
                          </Nav.Link>
                        </>
                      )}
                    </>
                  )}

                  {isAdmin && (
                    <Nav.Link
                      as={Link}
                      to="/admin/create-gangsheet"
                      active={pathname.startsWith("/admin/create-gangsheet")}
                    >
                      <AiOutlineSafetyCertificate
                        style={{ marginRight: "8px" }}
                      />{" "}
                      Create Gangsheet
                    </Nav.Link>
                  )}

                  <Nav.Link onClick={handleLogout}>
                    <FiLogOut style={{ marginRight: "8px" }} /> Logout
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </>
      </Container>
      <button
        className={`toggle-button ${sidebarLeft ? "active" : ""}`}
        onClick={handleSidebarToggle}
      >
        <div>
          <BiChevronLeft />
        </div>
      </button>
    </Navbar>
  );
};

export default Sidebar;
